import React from 'react';
import ServiceCard from '../components/ServiceCard'; // Assuming ServiceCard will be in components
// import { Link } from 'react-router-dom'; // If using React Router for navigation

// Placeholder data - this will likely come from an API or a data file
const servicesData = [
  {
    id: 1,
    name: 'Air Conditioning Services',
    description: 'Keep your Houston home cool and comfortable. We offer expert AC repair, installation, and replacement services for all major brands.',
    icon: 'path/to/ac-icon.svg', // Replace with actual icon path or component
    learnMoreLink: '/services/air-conditioning',
    image: '/images/services/airconditioning.png' // Updated path to match actual file location
  },
  {
    id: 2,
    name: 'Furnace & Heating Experts',
    description: 'Reliable heating solutions to keep you warm during colder days. Expert furnace repair, installation, and maintenance.',
    icon: 'path/to/heating-icon.svg',
    learnMoreLink: '/services/heating',
    image: '/images/heating-placeholder.jpg' // Placeholder
  },
  {
    id: 3,
    name: 'HVAC Maintenance Plans',
    description: 'Prevent costly breakdowns and extend the life of your system with our comprehensive maintenance plans.',
    icon: 'path/to/maintenance-icon.svg',
    learnMoreLink: '/services/maintenance',
    image: '/images/maintenance-placeholder.jpg' // Placeholder
  },
  {
    id: 4,
    name: 'Indoor Air Quality',
    description: 'Breathe cleaner, healthier air. We offer solutions like air purifiers, humidifiers, and ventilation services.',
    icon: 'path/to/iaq-icon.svg',
    learnMoreLink: '/services/indoor-air-quality',
    image: '/images/natural.png' // Placeholder
  },
  {
    id: 5,
    name: 'Commercial HVAC',
    description: 'Tailored HVAC solutions for businesses in Houston to ensure optimal comfort and efficiency for your operations.',
    icon: 'path/to/commercial-icon.svg',
    learnMoreLink: '/services/commercial-hvac',
    image: '/images/commercial-placeholder.jpg' // Placeholder
  },
];

const ServicesPage = () => {
  return (
    <div className="bg-brand-background min-h-screen">
      {/* Header Section */}
      <header
        className="relative py-12 md:py-20 text-center text-white bg-cover bg-center"
        style={{ backgroundImage: "url('/images/servicebanner.png')" }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="container mx-auto px-4 relative z-10">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">
            Quality Air Houston: Your Expert HVAC Solutions
          </h1>
          <p><br></br><br></br><br></br><br></br><br></br><br></br></p>
        </div>
      </header>

      {/* Service Categories Grid/List Section */}
      <section className="py-12 md:py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {servicesData.map((service) => (
              <ServiceCard
                key={service.id}
                name={service.name}
                description={service.description}
                // icon={service.icon} // Pass icon if using icons
                image={service.image} // Pass image if using images
                learnMoreLink={service.learnMoreLink}
              />
            ))}
          </div>
        </div>
      </section>

      {/* General Call to Action (CTA) Section */}
      <section className="py-12 md:py-20 bg-brand-green-light"> {/* Or bg-gray-100 */}
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-brand-gray-dark mb-4">
            Ready to Improve Your Comfort?
          </h2>
          <p className="text-lg text-brand-gray mb-8 max-w-2xl mx-auto">
            Contact Quality Air Houston today for a consultation, a free estimate on new installations, or to schedule your service. Our Houston-based experts are here to help!
          </p>
          <div className="flex flex-col sm:flex-row justify-center items-center gap-4">
            <a
              href="/request-quote" // Or trigger modal
              className="bg-brand-accent hover:bg-brand-accent-dark text-white font-semibold py-3 px-6 rounded-lg shadow-md transition duration-300 ease-in-out w-full sm:w-auto"
            >
              Schedule Service Online
            </a>
            <a
              href="tel:+1YOURPHONENUMBER" // Replace with actual phone number
              className="bg-brand-green hover:bg-brand-green-dark text-white font-semibold py-3 px-6 rounded-lg shadow-md transition duration-300 ease-in-out w-full sm:w-auto" // Or outline style: border border-brand-green text-brand-green hover:bg-brand-green hover:text-white
            >
              Call Us: [Your Phone Number]
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage; 